import * as IoC from 'typescript-ioc';
import { IEmailTemplateByIdRequestParams, IEmailTemplateField, IEmailTemplateFieldRequestParams, IEmailTemplatesDAO, IEmailVariable } from '../email-templates.dao';
import { IApiClient } from '../../infrastructure/api-client';
import * as EMAIL_TEMPLATES from '../../constants/api/email-templates.constants';
import { EMAIL_LIST_TYPE } from '../../constants/email-variables.constants';

class EmailTemplatesDAO implements IEmailTemplatesDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {}

    public getEmailVariables = async (params: { accountId: number; type: EMAIL_LIST_TYPE }): Promise<IEmailVariable[]> => {
        const response = await this.apiClient.get<IEmailVariable[]>(EMAIL_TEMPLATES.EMAIL_VARIABLES_URL, params);
        return response.parsedResponse;
    };

    public getEmailTemplatesList = async (params: { accountId: number }): Promise<IEmailTemplateField[]> => {
        const response = await this.apiClient.get<IEmailTemplateField[]>(EMAIL_TEMPLATES.GET_EMAIL_TEMPLATES_LIST, params);
        return response.parsedResponse;
    };

    public createEmailTemplate = async (params: IEmailTemplateFieldRequestParams): Promise<IEmailTemplateField> => {
        const response = await this.apiClient.post<IEmailTemplateField>(EMAIL_TEMPLATES.CREATE_UPDATE_EMAIL_TEMPLATES, params);
        return response.parsedResponse;
    };

    public updateEmailTemplate = async (params: IEmailTemplateField): Promise<IEmailTemplateField> => {
        const response = await this.apiClient.put<IEmailTemplateField>(EMAIL_TEMPLATES.CREATE_UPDATE_EMAIL_TEMPLATES, params);
        return response.parsedResponse;
    };

    public deleteEmailTemplate = async (params: IEmailTemplateByIdRequestParams): Promise<void>=> {
        await this.apiClient.delete<IEmailTemplateField>(EMAIL_TEMPLATES.EMAIL_TEMPLATE_BY_ID, params);
    };

    public getTemplateById = async (params: IEmailTemplateByIdRequestParams): Promise<IEmailTemplateField> => {
        const url = params.meetingId
            ? EMAIL_TEMPLATES.GET_MEETING_EMAIL_TEMPLATE_BY_ID
            : EMAIL_TEMPLATES.EMAIL_TEMPLATE_BY_ID
        ;
        const response = await this.apiClient.get<IEmailTemplateField>(url, params);
        return response.parsedResponse;
    };

    public sendEmail = async (params: IEmailTemplateFieldRequestParams): Promise<void> => {
        await this.apiClient.post<void>(EMAIL_TEMPLATES.SEND_EMAIL, params);
    };
}

export { EmailTemplatesDAO };